import React from 'react';
import Icon from '../../../components/AppIcon';

const BidActivityFeed = ({ bids, loading }) => {
  if (loading) {
    return (
      <div className="bg-card border border-border rounded-xl p-6 h-80 animate-pulse">
        <div className="h-5 bg-muted rounded w-40 mb-4" />
        <div className="space-y-3">
          {[1, 2, 3, 4]?.map(i => (
            <div key={i} className="h-14 bg-muted/40 rounded-lg" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-xl p-6 flex flex-col h-full">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-base font-semibold text-foreground">Recent Bids</h3>
          <p className="text-xs text-muted-foreground mt-0.5">Latest bids on your auctions</p>
        </div>
        <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Activity" size={16} className="text-primary" />
        </div>
      </div>
      {bids?.length === 0 ? (
        <div className="flex-1 flex flex-col items-center justify-center text-center py-8">
          <Icon name="Inbox" size={36} className="text-muted-foreground mb-3" />
          <p className="text-sm text-muted-foreground">No bids received yet</p>
        </div>
      ) : (
        <div className="space-y-2 overflow-y-auto max-h-64 pr-1">
          {bids?.map((bid, i) => (
            <div
              key={bid?.id || i}
              className="flex items-center gap-3 p-3 rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors"
            >
              <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${
                bid?.is_winning ? 'bg-green-500/10' : 'bg-muted'
              }`}>
                <Icon
                  name={bid?.is_winning ? 'Crown' : 'User'}
                  size={14}
                  className={bid?.is_winning ? 'text-green-500' : 'text-muted-foreground'}
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-medium text-foreground truncate">
                  {bid?.auctionTitle || 'Auction'}
                </p>
                <p className="text-xs text-muted-foreground">
                  {bid?.created_at ? new Date(bid.created_at)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—'}
                </p>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-sm font-bold text-primary">
                  ${parseFloat(bid?.bid_amount || 0)?.toFixed(2)}
                </p>
                {bid?.is_winning && (
                  <span className="text-xs text-green-500 font-medium">Winning</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BidActivityFeed;
